import { defineStyleConfig, extendTheme, type ThemeConfig } from "@chakra-ui/react";
import { ButtonTheme } from "./components/button";
import { InputTheme } from "./components/input";
import { ModalTheme } from "./components/modal";
import { PopoverTheme } from "./components/popover";
import { tooltipTheme } from "./components/tooltip";

const config: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

const breakpoints = {
  md: "1440px",
  lg: "1920px",
};

export const theme = extendTheme({
  breakpoints,
  config,
  styles: {
    global: {
      html: {
        overflow: "hidden",
      },
      body: {
        overflow: "hidden",
        overflowX: "auto",
      },
      "*:focus-visible": {
        outline: "none",
        boxShadow: "none",
      },
      "*[data-focus-visible]": {
        outline: "none",
        boxShadow: "none",
      },
    },
  },
  layerStyles: {
    fillTag: {
      base: {
        color: "text.primary",
        bg: "transparent",
      },
    },
    fillTagSelected: {
      color: "text.disabled",
      bg: "text.primary",
    },
    disabled: {
      opacity: 0.4,
      cursor: "not-allowed",
    },
  },
  colors: {
    brand: {
      primary: "#36C19E",
      hover: "#5CCFAE",
      active: "#1DB693",
      disabled: "#92EED5",
      500: "#36C19E",
    },
    whiteAlpha: {
      250: "rgba(255,255,255,0.1)",
    },
    bg: {
      boardBg: "#242424",
      panelBg: "#323232",
      secondary: "#3a3a3a",
      modal: "#585858",
    },
    border: {
      default: "#e5e5e5",
      seperator: "#4d4d4d",
      buttonOutline: "#cccccc",
    },
    line: {
      darkGray: "#DDDDDD",
    },
    fill: {
      scrollBarColor: "rgba(255,255,255,0.1)",
      icon: "#5f5f5f",
      emphasis: "#C9CDD4",
      button: "#424242",
    },
    text: {
      primary: "#5F5F5F",
      icon: "#b3b3b3",
      iconButton: "#eeeeee",
      title: "#e5e5e5",
      input: "#ffffff",
      caption: "#cccccc",
      iconButtonHover: "#656565",
      secondary: "#999999",
      disabled: "#bfbfbf",
      subtitle: "#bfbfbf",
      lightDisabled: "#DCDCDC",
      placeholder: "#8C8C8C",
    },
    select: {
      value: "white",
      bg: "#656565",
      hover: "#656565",
    },
    success: {
      default: "#00B42A",
    },
  },
  components: {
    Button: ButtonTheme,
    Modal: ModalTheme,
    Popover: PopoverTheme,
    Tooltip: tooltipTheme,
    Input: InputTheme,
    CloseButton: defineStyleConfig({
      baseStyle: {
        _focusVisible: {
          boxShadow: "none",
        },
      },
    }),
  },
});
